import { useContext, useEffect, useState } from 'react';

import { Context } from '../../../context/UserContext';
import { useNavigateParams } from '../../../hooks/useNavigateParams';
import useFlashMessage from '../../../hooks/useFlashMessage';
import { getEmpresaScope } from '../../../helpers/sessionEmpresa';

import * as EmpresaAPI from '../../../api/empresa';
import * as TabelaAPI from '../../../api/tabela';
import CrudsAPI from '../../../api/CRUDs';

import Form from './Form';
import useSubGrupoModule from './modules/useSubGrupoModule';
import styles from '../../form/Form.module.css';

function removerCamposLocais(item) {
    const subGrupo = { ...item };
    delete subGrupo._localId;
    return subGrupo;
}

const CreateOrEdit = () => {
    const { empresaId } = getEmpresaScope();
    const [dados, setDados] = useState({
        empresaId,
        ativo: true,
        produto: false,
        centroCusto: false,
        subGrupos: [],
    });
    const [token] = useState(localStorage.getItem('token') || '');
    const [optionsEmpresa, setOptionsEmpresa] = useState([]);

    const { parametro } = useContext(Context);
    const { setFlashMessage } = useFlashMessage();
    const navigate = useNavigateParams();
    const urlParams = new URLSearchParams(window.location.search);

    const pathname = '/Grupos';
    const ul = urlParams.get('ul');
    const li = urlParams.get('li');
    const tipo = urlParams.get('tipo');
    const operacaoUUID = urlParams.get('operacao');
    const uuid = urlParams.get('uuid');
    const btnText = urlParams.get('btnText');

    const params = new URLSearchParams({
        ul,
        li,
        tipo,
        operacao: operacaoUUID,
        uuid,
        btnText,
    });

    const subGrupoModule = useSubGrupoModule({
        dados,
        setDados,
        parametro,
    });

    useEffect(() => {
        if (!token) {
            navigate('/Auth', { replace: true });
        }
    }, [token, navigate]);

    useEffect(() => {
        const carregar = async () => {
            try {
                const empresas = await EmpresaAPI.empresa(empresaId);
                setOptionsEmpresa(empresas);

                if (uuid && uuid !== 'null') {
                    const response = await CrudsAPI.grupo.consulta(uuid);
                    setDados(response.data);
                }
            } catch (error) {
                console.error(error);
                setFlashMessage(error?.response?.data?.message || 'Erro ao carregar o grupo.', error?.response?.data?.type || 'error');
            }
        };

        carregar();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [uuid]);

    const handleChange = (event) => {
        const { name, value, checked, type: inputType } = event.target;

        setDados((prev) => ({
            ...prev,
            [name]: inputType === 'checkbox' ? checked : value,
        }));
    };

    const handleOnBlur = async (event) => {
        if (event.target.name !== 'descricao' || String(btnText ?? '').toLowerCase() !== 'cadastrar') return;

        const duplicidade = await TabelaAPI.duplicidadeDescricao(dados.empresaId, 'Grupo', event.target.value);

        if (!duplicidade?.uuid) return;

        setFlashMessage('Registro em duplicidade!', 'warning');
        navigate('/Grupos/CreateOrEdit', {
            uuid: duplicidade.uuid,
        });
    };

    async function managerDados(formData) {
        let urlNavigate = pathname;

        const grupoPayload = {
            uuid: formData.uuid,
            ativo: formData.ativo,
            empresaId: formData.empresaId,
            descricao: formData.descricao,
            produto: formData.produto,
            centroCusto: formData.centroCusto,
        };

        try {
            let response;

            if (formData.grupoId) {
                response = await CrudsAPI.grupo.editar(grupoPayload);
            } else {
                response = await CrudsAPI.grupo.cadastrar({
                    ...grupoPayload,
                    subGrupos: (formData.subGrupos ?? []).map(removerCamposLocais),
                });

                if (response.status === 202) {
                    setDados(response.data);
                    response.data.message = 'Registro em duplicidade!';
                    response.data.type = 'warning';
                    urlNavigate = `${pathname}/CreateOrEdit`;
                    params.set('uuid', response.data.uuid);
                    params.set('btnText', 'Atualizar');
                }
            }

            setFlashMessage(response.data.message, response.data.type);

            setTimeout(() => {
                navigate(urlNavigate, params);
            }, parametro.msgTempo * 1000);
        } catch (error) {
            console.error(error);
            setFlashMessage(error?.response?.data?.message || 'Erro ao salvar o grupo.', error?.response?.data?.type || 'error');
        }
    }

    return (
        <section className={`${styles.form_container} ${styles[parametro.tema]}`}>
            <Form
                dados={dados}
                handleSubmit={managerDados}
                handleChange={handleChange}
                handleOnBlur={handleOnBlur}
                btnText={btnText}
                optionsEmpresa={optionsEmpresa}
                onVoltar={() => navigate(pathname)}
                subGrupos={subGrupoModule.itens}
                getSubGrupoRowId={subGrupoModule.getSubGrupoRowId}
                mrtDefault={subGrupoModule.mrtDefault}
                dialogSubGrupo={subGrupoModule.dialog}
                subGrupoExcluir={subGrupoModule.itemExcluir}
                subGrupoLoading={subGrupoModule.loading}
                onNovoSubGrupo={subGrupoModule.abrirNovo}
                onEditarSubGrupo={subGrupoModule.abrirEdicao}
                onFecharSubGrupo={subGrupoModule.fecharDialog}
                onConfirmarSubGrupo={subGrupoModule.confirmar}
                onSolicitarExcluirSubGrupo={subGrupoModule.solicitarExclusao}
                onCancelarExcluirSubGrupo={subGrupoModule.cancelarExclusao}
                onConfirmarExcluirSubGrupo={subGrupoModule.confirmarExclusao}
                podeIncluirSubGrupo={subGrupoModule.podeIncluir}
                podeEditarSubGrupo={subGrupoModule.podeEditar}
                podeExcluirSubGrupo={subGrupoModule.podeExcluir}
            />
        </section>
    );
};

export default CreateOrEdit;
